var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.224,
    height: 13.281,
    viewBox: "0 0 13.224 13.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.04 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.356,3.9h7.88v.316a.949.949,0,0,0,.949.949H12.45a.949.949,0,0,0,.949-.949V3.9h1.474a.316.316,0,1,0,0-.632H13.4V2.949A.949.949,0,0,0,12.45,2H11.185a.949.949,0,0,0-.949.949v.316H2.356a.316.316,0,0,0,0,.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.92,19.265H12.137v-.316A.949.949,0,0,0,11.188,18H9.924a.949.949,0,0,0-.949.949v.316H2.366a.316.316,0,1,0,0,.632H8.975v.316a.949.949,0,0,0,.949.949h1.265a.949.949,0,0,0,.949-.949V19.9H14.92a.316.316,0,1,0,0-.632Z",
    transform: "translate(-0.004 -5.881)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.147,13.162H7.412a.949.949,0,0,0,.949-.949V11.9H14.97a.316.316,0,1,0,0-.632H8.361v-.316A.949.949,0,0,0,7.412,10H6.147a.949.949,0,0,0-.949.949v.316H2.416a.316.316,0,0,0,0,.632H5.2v.316A.949.949,0,0,0,6.147,13.162Z",
    transform: "translate(-0.022 -2.941)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7b47688b.svg";
export { ForwardRef as ReactComponent };